import { render } from "./AdditionalNotes.vue?vue&type=template&id=4cf9db3e&scoped=true"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js"

import "./AdditionalNotes.vue?vue&type=style&index=0&id=4cf9db3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf9db3e"]])

export default __exports__